import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopMembers } from 'src/services/Scope.client';

export type Mode = 'light' | 'dark';

export interface SettingsState {
  isCompanionCollapsed: boolean;
  lastScopeCreated: Record<string, TopMembers>;
  isMfpPivotCollapsed: boolean;
  isMfpMacroSummariesCollapsed: boolean;
  themeMode: Mode;
}
const initialState: SettingsState = {
  isCompanionCollapsed: false,
  lastScopeCreated: {} as Record<string, TopMembers>,
  isMfpPivotCollapsed: false,
  isMfpMacroSummariesCollapsed: false,
  themeMode: 'light',
};

const uiPoseSlice = createSlice({
  name: 'uiPose',
  initialState: initialState,
  reducers: {
    setLastScopeCreated: (state, action: PayloadAction<[string, TopMembers]>) => {
      state.lastScopeCreated[action.payload[0]] = action.payload[1];
    },
    toggleCompanionCollapse: (state) => {
      state.isCompanionCollapsed = !state.isCompanionCollapsed;
    },
    setMfpPivotCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isMfpPivotCollapsed = action.payload;
    },
    setMfpMacroSummariesCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isMfpMacroSummariesCollapsed = action.payload;
    },
    toggleMode: (state) => {
      state.themeMode = state.themeMode === 'dark' ? 'light' : 'dark';
    },
  },
});

export const { setLastScopeCreated, toggleCompanionCollapse, setMfpPivotCollapsed, setMfpMacroSummariesCollapsed, toggleMode } = uiPoseSlice.actions;

export default uiPoseSlice.reducer;
